<template>
  <div class="card text-white bg-gradient-warning mb-2">
    <div class="card-body py-2">
      <h5 class="card-title mb-0">
        <router-link class="text-decoration-none text-white" :to="routeParams">
          <folder-upload-icon v-if="up" />
          <folder-icon v-if="!up" /> {{ description }}
        </router-link>
      </h5>
    </div>
  </div>
</template>

<script>
import FolderIcon from "vue-material-design-icons/Folder";
import FolderUploadIcon from "vue-material-design-icons/FolderUpload";

export default {
  name: "LibraryFolder",
  components: {
    FolderIcon,
    FolderUploadIcon,
  },
  props: {
    description: {},
    category: {
      /* 0 == Home */
      type: Number,
      default: 0,
    },
    listOptions: { type: Object, required: true },
    up: { type: Boolean, default: false },
  },
  methods: {
    getCategory(category) {
      if (category.length > 0) {
        return category[category.length - 1];
      }
      return null;
    },
  },
  computed: {
    routeParams() {
      var lo = { ...this.listOptions };

      if (this.category === 0) {
        return {
          name: "library.list",
          query: lo,
        };
      }
      return {
        name: "library.category",
        params: { category: this.category },
        query: lo,
      };
    },
  },
};
</script>

<style scoped></style>
